module.exports = __webpack_public_path__ + "static/te-explicamos-white-logo.d4bee0ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/te-explicamos-white-logo.svg
// module id = 830
// module chunks = 14943580662024